type ValidationRule = {
  validator: (_: unknown, value?: string) => Promise<void>;
};

const getPlaceholderValidationRule = (
  placeholders: string[],
): ValidationRule => ({
  validator: async (_, value) => {
    const isEmpty = !value || value.trim() === "";

    if (isEmpty) {
      return;
    }

    const missingPlaceholders = placeholders.filter(
      (placeholder) => !value.includes(placeholder),
    );
    const hasMissingPlaceholders = missingPlaceholders.length > 0;

    if (hasMissingPlaceholders) {
      throw new Error(`Must include ${missingPlaceholders.join(", ")}`);
    }
  },
});

export default getPlaceholderValidationRule;
